import axios from 'axios'

import getHeaders from '../helpers/headers'
import config from '../../constants/endpoints.js'

const { dnsDashboard } = config

const route = `${dnsDashboard}/company/download`

/**
 * download data for current company
 *
 * @returns {Promise<{ url: string }>}
 */
const downloadData = async () => {
  const { data } = await axios({
    url: `${route}/data`,
    headers: getHeaders(true),
    timeout: 20 * 60 * 1000, // 20 minutos
    method: 'get',
  })

  return data
}

export default {
  downloadData
}
